export default __webpack_public_path__ + "static/media/financiera.b37e296f.png";